import { IEdiUploadMapping } from "../../../types/ediConversionFile";

// Mirrors the backend's validateMappingSet (CLE-2424). INSTITUTIONAL and PROFESSIONAL_ANESTHESIA
// may each be mapped to a single provider; PROFESSIONAL_PROVIDER may be mapped to more than one
// provider, but only to split by place of service — every such rule must select a non-empty,
// pairwise-disjoint place of service so each claim routes to exactly one provider (no double
// import). Place-of-service comparison uses the API's raw category values (e.g. "Inpatient",
// "Non-Facility"), matching how the modal stores them. Returns a user-facing error string, or null
// when the mapping set is valid.
export const validateEdiMappingSet = (
  mappings: IEdiUploadMapping[]
): string | null => {
  const counts: Record<string, number> = {};
  mappings.forEach((m) => {
    counts[m.claimType] = (counts[m.claimType] ?? 0) + 1;
  });

  if ((counts.INSTITUTIONAL ?? 0) > 1) {
    return "Institutional claims can map to only one provider.";
  }
  if ((counts.PROFESSIONAL_ANESTHESIA ?? 0) > 1) {
    return "Anesthesia claims can map to only one provider.";
  }

  const professional = mappings.filter(
    (m) => m.claimType === "PROFESSIONAL_PROVIDER"
  );
  if (professional.length > 1) {
    const seen = new Set<string>();
    for (let i = 0; i < professional.length; i += 1) {
      const pos = professional[i].placeOfServiceFilter ?? [];
      if (pos.length === 0) {
        return "When routing professional claims to more than one provider, set a place of service (Facility or Non-Facility) on each rule.";
      }
      for (let j = 0; j < pos.length; j += 1) {
        if (seen.has(pos[j])) {
          return "Each place of service can map to only one provider — adjust the Facility / Non-Facility selections.";
        }
        seen.add(pos[j]);
      }
    }
  }

  return null;
};
